
export type EventType = 'bootcamp' | 'lex' | 'soft_landing' | 'standard' | 'vip' | 'first_tuesday';
export type EventVisibilityType = 'internal' | 'external' | 'hybrid';

export interface Event {
  id: string;
  title: string;
  description: string | null;
  start_date: string;
  end_date: string | null;
  location: string | null;
  image_url: string | null;
  capacity: number | null;
  is_premium: boolean;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  event_type: EventType;
  duration_days: number | null;
  program_details: string | null;
  destination_country: string | null;
  min_participants: number | null;
  max_participants: number | null;
  target_audience: string | null;
  visibility_type: EventVisibilityType;
  public_slug: string | null;
  public_registration_enabled: boolean;
  external_registration_limit: number | null;
  registration_form_fields: {
    name: boolean;
    email: boolean;
    phone: boolean;
    company: boolean;
  };
  landing_page_content: Record<string, any>;
  seo_metadata: Record<string, any>;
}

export type EventStatus = 'upcoming' | 'ongoing' | 'past';

export interface EventWithStatus extends Event {
  status: EventStatus;
  attendees?: number;
}

export type EventFilterOptions = {
  searchTerm: string;
  status: string;
  location: string;
  is_premium: boolean | null;
  eventType: string;
};

export const EVENT_TYPES = {
  first_tuesday: {
    id: 'first_tuesday',
    label: 'First Tuesday',
    description: 'Événement mensuel récurrent de networking NODE Tech',
    color: 'hsl(239, 84%, 67%)',
    bgColor: 'hsl(239, 84%, 95%)',
    icon: 'CalendarClock',
    adminOnly: true,
    defaultVisibility: 'external' as EventVisibilityType,
    isRecurring: true
  },
  bootcamp: {
    id: 'bootcamp',
    label: 'Bootcamp',
    description: 'Formation intensive et programmes d\'accompagnement',
    color: 'hsl(var(--success))',
    bgColor: 'hsl(var(--success) / 0.1)',
    icon: 'Zap'
  },
  lex: {
    id: 'lex',
    label: 'LEX',
    description: 'Learning Expeditions - Voyages d\'affaires vers écosystèmes tech',
    color: 'hsl(var(--primary))',
    bgColor: 'hsl(var(--primary) / 0.1)',
    icon: 'Plane'
  },
  soft_landing: {
    id: 'soft_landing',
    label: 'Soft Landing',
    description: 'Accompagnement pour intégration dans différents pays',
    color: 'hsl(var(--warning))',
    bgColor: 'hsl(var(--warning) / 0.1)',
    icon: 'MapPin'
  },
  standard: {
    id: 'standard',
    label: 'Événement',
    description: 'Événements et conférences traditionnels',
    color: 'hsl(var(--muted-foreground))',
    bgColor: 'hsl(var(--muted) / 0.1)',
    icon: 'Calendar'
  },
  vip: {
    id: 'vip',
    label: 'VIP',
    description: 'Événements exclusifs réservés aux membres Enterprise',
    color: 'hsl(var(--warning))',
    bgColor: 'hsl(var(--warning) / 0.1)',
    icon: 'Crown'
  }
} as const;

export interface ExternalRegistration {
  id: string;
  event_id: string;
  guest_name: string;
  guest_email: string;
  guest_phone: string | null;
  guest_company: string | null;
  custom_fields_data: Record<string, any>;
  registration_status: 'pending' | 'confirmed' | 'cancelled';
  ticket_id: string | null;
  created_account: boolean;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  created_at: string;
  updated_at: string;
}
